import {
  Flex,
  Text,
  H400,
} from 'web-styled';

import * as S from './styled';

type Props = {
  title?: string,
  messages?: string[],
};

const NotFound = ({ title, messages }: Props) => (
  <Flex
    column
    fillSpace
    align="center"
    justify="center"
    spacing={15}
  >
    <S.Icon />
    <Flex
      column
      spacing={2}
      align="center"
      justify="center"
    >
      {title && (
        <H400 color="#e54d42">
          {title}
        </H400>
      )}
      {messages && messages.map(m => (
        <div key={m}>
          <Text color="#e54d42">
            {m}
          </Text>
        </div>
      ))}
    </Flex>
  </Flex>
);

export default NotFound;
